/*
 * rebooking.js
 *
 * Description: Holds 'Stores' Logic for Module:'Rebooking'.
 *
 * This file is part of: "http://apps.sundair.com/", "Sundair-2019"
 * Copyright 2018,2019,2020,2021,2022 Sundair GmbH
 * Contact:  http://www.sundair.com/
 * @author Learek <michael.broeker@sundair.com>
 *
 */
import Vue from 'vue';
import axios from 'axios';
import { eventBus } from '../../../main';


//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$   /$$                /$$
// #   /$$__  $$ | $$               | $$
// #  | $$  \__//$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  |  $$$$$$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #   \____  $$ | $$     /$$$$$$$  | $$    | $$$$$$$$
// #   /$$  \ $$ | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  |  $$$$$$/ |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #   \______/   \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
const state = {

    // >>> 'Bookingno for Rebooking' ----------------------
    flagRebookingBookingnoLoginIsReadyForLogin: false, // 'Bookingno Login' ready?
    flagRebookingShowBookingnoSearchResults: false, // 'Rebooking Get Booking' done

    rebookingUsersSearchDataBookingno: null, // User Input
    rebookingGetBookingResults: {}, // SearchResults (Bookingno Rebooking)

    rebookingAllPaxCheckboxClicked: [],
    rebookingIdTicketOutwards: [],
    rebookingIdTicketReturn: [],

    rebookingUsersSearchDataFlightSearch: null, // User Input for Call
    rebookingFlightSearchResults: {}, // Results (Rebooking Flights)

    rebookingFlightIdSelectedOutward: null,
    rebookingFlightIdSelectedReturn: null,
    rebookingPriceIdSelectedOutward: null,
    rebookingPriceIdSelectedReturn: null,
    flagRebookingOutwardFlightSelected: false,
    flagRebookingReturnFlightSelected: false,

    rebookingUsersSearchDataGetRebookingKey: null, // User Input for Call
    rebookingGetRebookingKeyResults: {}, // Results (GetRebookingKey)

    rebookingUsersSearchDataProcessrebooking: null, // User Input for Call
    rebookingProcessRebookingResults: {}, // Results (processRebooking)

};




//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$              /$$     /$$
// #   /$$__  $$            | $$    | $$
// #  | $$  \__/  /$$$$$$  /$$$$$$ /$$$$$$    /$$$$$$   /$$$$$$  /$$$$$$$
// #  | $$ /$$$$ /$$__  $$|_  $$_/|_  $$_/   /$$__  $$ /$$__  $$/$$_____/
// #  | $$|_  $$| $$$$$$$$  | $$    | $$    | $$$$$$$$| $$  \__/  $$$$$$
// #  | $$  \ $$| $$_____/  | $$ /$$| $$ /$$| $$_____/| $$      \____  $$
// #  |  $$$$$$/|  $$$$$$$  |  $$$$/|  $$$$/|  $$$$$$$| $$      /$$$$$$$/
// #   \______/  \_______/   \___/   \___/   \_______/|__/     |_______/
// #
//-----------------------------------------------------------------------------/
const getters = {

    /***************************************************************************
    * Getters: 'Bookingno Rebooking', Control Flags
    ***************************************************************************/
    /***************************************************************************
    * get_FlagRebookingBookingnoLoginIsReadyForLogin()
    *
    * Desc: Return Flag: 'Bookingno Rebooking is ready for Login?'
    * Note:
    *
    */
    get_FlagRebookingBookingnoLoginIsReadyForLogin: state => {

        return state.flagRebookingBookingnoLoginIsReadyForLogin;

    }, // eo function get_FlagRebookingBookingnoLoginIsReadyForLogin()


    /***************************************************************************
    * get_FlagRebookingShowBookingnoSearchResults()
    *
    * Desc: Return Flag: 'Show Bookingno Rebooking Overview Section'
    * Note:
    *
    */
    get_FlagRebookingShowBookingnoSearchResults: state => {

        return state.flagRebookingShowBookingnoSearchResults;

    }, // eo function get_FlagRebookingShowBookingnoSearchResults()




    /***************************************************************************
    * Getters: 'Bookingno Rebooking'
    ***************************************************************************/
    /***************************************************************************
    * get_RebookingUsersSearchDataBookingno()
    *
    * Desc: Returns entire 'Users Search Data'.
    * Note:
    *
    */
    get_RebookingUsersSearchDataBookingno: state => {

        return state.rebookingUsersSearchDataBookingno;

    }, // eof get_RebookingUsersSearchDataBookingno()


    /***************************************************************************
    * get_RebookingGetBookingResults()
    *
    * Desc: Returns entire 'getbooking' Result.
    * Note:
    *
    */
    get_RebookingGetBookingResults: state => {

        return state.rebookingGetBookingResults;

    }, // eof get_RebookingGetBookingResults()


    /***************************************************************************
    * get_RebookingTickets()
    *
    * Desc: Returns Pax List with its Services.
    * Note: payload: { idFlight: flight.idFlight, whichCall: 'getbooking' }
    * Note: Possible whichCall(s): 'getbooking', 'getrebookingkey'
    *
    */
    get_RebookingTickets: state => payload => {

        let paxSrvcsList = [];


        // >>> Tickets from Call: 'getbooking' ------------
        if (payload.whichCall === 'getbooking') {
            state.rebookingGetBookingResults.tickets.forEach((ticket, i) => {
                if (ticket.idFlight === payload.idFlight) {
                    state.rebookingGetBookingResults.passengers.forEach((pax, i) => {
                        if (ticket.idPax === pax.idPax) {
                            paxSrvcsList.push({
                                pax: pax,
                                ticket: ticket
                            });
                        }
                    });
                }
            });
        }

        // >>> Tickets from Call: 'getrebookingkey' ------------
        if (payload.whichCall === 'getrebookingkey') {
            state.rebookingGetRebookingKeyResults.tickets.forEach((ticket, i) => {
                if (ticket.idFlight === payload.idFlight) {
                    state.rebookingGetRebookingKeyResults.passengers.forEach((pax, i) => {
                        if (ticket.idPax === pax.idPax) {
                            paxSrvcsList.push({
                                pax: pax,
                                ticket: ticket
                            });
                        }
                    });
                }
            });
        }


        return paxSrvcsList;

    }, // eo function get_RebookingTickets()


    /***************************************************************************
    * get_GotFlightsToRebook()
    *
    * Desc: Returns
    * Note: payload: { flightdirection: flightdirection' }
    * Note:
    *
    */
    get_GotFlightsToRebook: state => payload => {

        let gotFlightsToRebook = false;


        // >>> Tickets from Call: 'getbooking' ------------
        if (payload.flightdirection === 'outward') {
            state.rebookingGetBookingResults.outwardFlights.forEach((flight, i) => {
                if (flight.rebookable === true) {
                    gotFlightsToRebook = true;
                }
            });
        }

        if (payload.flightdirection === 'return') {
            state.rebookingGetBookingResults.inboundFlights.forEach((flight, i) => {
                if (flight.rebookable === true) {
                    gotFlightsToRebook = true;
                }
            });
        }


        return gotFlightsToRebook;

    }, // eo function get_GotFlightsToRebook()


    /***************************************************************************
    * getRebookingOriginalBookingHasOutwardFlight()
    *
    * Desc: Return if original Booking has an 'Outward Flight'?
    * Note:
    *
    */
    getRebookingOriginalBookingHasOutwardFlight: state => {

        let outwardFlightInOriginalBooking = false;


        if (state.rebookingGetBookingResults.outwardFlights.length > 0) {
            outwardFlightInOriginalBooking = true;
        } else {
            outwardFlightInOriginalBooking = false;
        }


        return outwardFlightInOriginalBooking;

    }, // eof getRebookingOriginalBookingHasOutwardFlight()


    /***************************************************************************
    * getRebookingOriginalBookingHasReturnFlight()
    *
    * Desc: Return if original Booking has a 'Inbound Flight'?
    * Note:
    *
    */
    getRebookingOriginalBookingHasReturnFlight: state => {

        let returnFlightInOriginalBooking = false;


        if (state.rebookingGetBookingResults.inboundFlights.length > 0) {
            returnFlightInOriginalBooking = true;
        } else {
            returnFlightInOriginalBooking = false;
        }


        return returnFlightInOriginalBooking;

    }, // eof getRebookingOriginalBookingHasReturnFlight()


    /***************************************************************************
    * getRebookingOriginalBookingRebookingFee()
    *
    * Desc: Return 'rebookingFee' from original Booking.
    * Note:
    *
    */
    getRebookingOriginalBookingRebookingFee: state => {

        return Number(state.rebookingGetBookingResults.rebookingFee);

    }, // eof getRebookingOriginalBookingRebookingFee()


    /***************************************************************************
    * getRebookingOriginalBookingHasInfant()
    *
    * Desc: Return 'has Infant' from original Booking via Pax.
    * Note:
    *
    */
    getRebookingOriginalBookingHasInfant: state => payload => {

        let hasInfant = false;


        state.rebookingGetBookingResults.tickets.forEach((ticket, i) => {
            if (+ticket.idPax === +payload.idPax && +ticket.idFlight === +payload.idFlight) {
                if (ticket.infantServices.length > 0) {
                    hasInfant = true;
                }
            }
        });


        return hasInfant;

    }, // eof getRebookingOriginalBookingHasInfant()


    /***************************************************************************
    * get_RebookingAllPaxCheckboxClicked()
    *
    * Desc: Return Array.
    * Note:
    *
    */
    get_RebookingAllPaxCheckboxClicked: state => {

        return state.rebookingAllPaxCheckboxClicked;

    }, // eof get_RebookingAllPaxCheckboxClicked()


    /***************************************************************************
    * getRebookingIdTicketOutwards()
    *
    * Desc: Return Array.
    * Note:
    *
    */
    getRebookingIdTicketOutwards: state => {

        return state.rebookingIdTicketOutwards;

    }, // eof getRebookingIdTicketOutwards()


    /***************************************************************************
    * getRebookingIdTicketReturn()
    *
    * Desc: Return Array.
    * Note:
    *
    */
    getRebookingIdTicketReturn: state => {

        return state.rebookingIdTicketReturn;

    }, // eof getRebookingIdTicketReturn()


    /***************************************************************************
    * getRebookingDepArprtName()
    *
    * Desc: Return DepArprtName.
    * Note:
    *
    */
    getRebookingDepArprtName: state => {

        return state.rebookingGetBookingResults.outwardFlights[0].departureAirport.location;

    }, // eof getRebookingDepArprtName()


    /***************************************************************************
    * getRebookingDesArprtName()
    *
    * Desc: Return DesArprtName.
    * Note:
    *
    */
    getRebookingDesArprtName: state => {

        return state.rebookingGetBookingResults.outwardFlights[0].destinationAirport.location;

    }, // eof getRebookingDesArprtName()


    /***************************************************************************
    * getRebookingDepArprtCode()
    *
    * Desc: Return DepArprtCode.
    * Note:
    *
    */
    getRebookingDepArprtCode: state => {

        return state.rebookingGetBookingResults.outwardFlights[0].departureAirport.iataCode;

    }, // eof getRebookingDepArprtCode()


    /***************************************************************************
    * getRebookingDesArprtCode()
    *
    * Desc: Return DesArprtCode.
    * Note:
    *
    */
    getRebookingDesArprtCode: state => {

        return state.rebookingGetBookingResults.outwardFlights[0].destinationAirport.iataCode;

    }, // eof getRebookingDesArprtCode()




    /***************************************************************************
    * Getters: RebookingFlightSearchResult
    ***************************************************************************/
    /***************************************************************************
    * get_RebookingUsersSearchDataFlightSearch()
    *
    * Desc: Return
    * Note:
    *
    */
    get_RebookingUsersSearchDataFlightSearch: state => {

        return state.rebookingUsersSearchDataFlightSearch;

    }, // eof get_RebookingUsersSearchDataFlightSearch()


    /***************************************************************************
    * get_RebookingFlightSearchResults()
    *
    * Desc: Return
    * Note:
    *
    */
    get_RebookingFlightSearchResults: state => {

        return state.rebookingFlightSearchResults;

    }, // eof get_RebookingFlightSearchResults()


    /***************************************************************************
    * get_FlagRebookingOutwardFlightSelected()
    *
    * Desc: Is 'Outward Flight' selected.
    * Note:
    *
    */
    get_FlagRebookingOutwardFlightSelected: state => {

        return state.flagRebookingOutwardFlightSelected;

    }, // eof get_FlagRebookingOutwardFlightSelected()


    /***************************************************************************
    * get_FlagRebookingReturnFlightSelected()
    *
    * Desc: Is 'Return Flight' selected.
    * Note:
    *
    */
    get_FlagRebookingReturnFlightSelected: state => {

        return state.flagRebookingReturnFlightSelected;

    }, // eof get_FlagRebookingReturnFlightSelected()


    /***************************************************************************
    * get_RebookingFlightIdSelectedOutward()
    *
    * Desc: Returns Selected Outward Flight Id.
    * Note:
    *
    */
    get_RebookingFlightIdSelectedOutward: state => {

        return state.rebookingFlightIdSelectedOutward;

    }, // eof get_RebookingFlightIdSelectedOutward()


    /***************************************************************************
    * get_RebookingFlightIdSelectedReturn()
    *
    * Desc: Returns Selected Return Flight Id.
    * Note:
    *
    */
    get_RebookingFlightIdSelectedReturn: state => {

        return state.rebookingFlightIdSelectedReturn;

    }, // eof get_RebookingFlightIdSelectedReturn()


    /***************************************************************************
    * get_RebookingPriceIdSelectedOutward()
    *
    * Desc: Returns Selected Outward Flight Price Id.
    * Note:
    *
    */
    get_RebookingPriceIdSelectedOutward: state => {

        return state.rebookingPriceIdSelectedOutward;

    }, // eof get_RebookingPriceIdSelectedOutward()


    /***************************************************************************
    * get_RebookingPriceIdSelectedReturn()
    *
    * Desc: Returns Selected Return Flight Price Id.
    * Note:
    *
    */
    get_RebookingPriceIdSelectedReturn: state => {

        return state.rebookingPriceIdSelectedReturn;

    }, // eof get_RebookingPriceIdSelectedReturn()




    /***************************************************************************
    * Getters: RebookingKey
    ***************************************************************************/
    /***************************************************************************
    * get_RebookingUsersSearchDataGetRebookingKey()
    *
    * Desc: Returns
    * Note:
    *
    */
    get_RebookingUsersSearchDataGetRebookingKey: (state, payload) => {

        return state.rebookingUsersSearchDataGetRebookingKey;

    }, // eof get_RebookingUsersSearchDataGetRebookingKey()


    /***************************************************************************
    * get_RebookingGetRebookingKeyResults()
    *
    * Desc: Returns
    * Note:
    *
    */
    get_RebookingGetRebookingKeyResults: state => {

        return state.rebookingGetRebookingKeyResults;

    }, // eof get_RebookingGetRebookingKeyResults()


    /***************************************************************************
    * get_RebookingGetRebookingTicketsTotal()
    *
    * Desc: Returns
    * Note:
    *
    */
    get_RebookingGetRebookingTicketsTotal: state => {

        let ticketsTotal = 0;


        state.rebookingGetRebookingKeyResults.tickets.forEach((ticket, i) => {
                ticketsTotal = parseFloat(ticketsTotal, 10) + parseFloat(ticket.rebookingTotal, 10);
        });


        return ticketsTotal;

    }, // eof get_RebookingGetRebookingTicketsTotal()




    /***************************************************************************
    * Getters: processRebookiong
    ***************************************************************************/
    /***************************************************************************
    * get_RebookingUsersSearchDataGetProcessRebooking()
    *
    * Desc:
    * Note:
    *
    */
    get_RebookingUsersSearchDataGetProcessRebooking: (state, payload) => {

        return state.rebookingUsersSearchDataProcessrebooking;

    }, // eof get_RebookingUsersSearchDataGetProcessRebooking()


    /***************************************************************************
    * get_RebookingProcessRebookingResults()
    *
    * Desc: Returns
    * Note:
    *
    */
    get_RebookingProcessRebookingResults: (state, payload) => {

        return state.rebookingProcessRebookingResults;

    }, // eof get_RebookingProcessRebookingResults()


    /***************************************************************************
    * get_RebookingProcessRebookingResultsTotal()
    *
    * Desc: Returns Total of all summed up Tickets.
    * Note: Funny Thing is .. 'rebookingPrice' is a the 'Total' here.
    *
    */
    get_RebookingProcessRebookingResultsTotal: (state, payload) => {

        let total = 0;


        total = parseFloat(state.rebookingProcessRebookingResults.rebookingPrice, 10);


        return total;

    }, // eof get_RebookingProcessRebookingResultsTotal()

};




//-----------------------------------------------------------------------------/
// #
// #   /$$      /$$             /$$                /$$
// #  | $$$    /$$$            | $$               | $$
// #  | $$$$  /$$$$ /$$   /$$ /$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  | $$ $$/$$ $$| $$  | $$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #  | $$  $$$| $$| $$  | $$  | $$     /$$$$$$$  | $$    | $$$$$$$$
// #  | $$\  $ | $$| $$  | $$  | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  | $$ \/  | $$|  $$$$$$/  |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #  |__/     |__/ \______/    \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
const mutations = {

    /***************************************************************************
    * Mutations: State Reset
    ***************************************************************************/
    /***************************************************************************
    * mut_set_stateResetRebooking()
    *
    * Desc: Reset State In Context:Rebooking.
    * Note:
    *
    */
    mut_set_stateResetRebooking: (context, payload) => {

        state.flagRebookingBookingnoLoginIsReadyForLogin = false;

    }, // eof mut_set_stateResetRebooking()




    /***************************************************************************
    * Mutations: 'Bookingno Rebooking', Control Flags
    ***************************************************************************/
    /***************************************************************************
    * mut_FlagRebookingBookingnoLoginIsReadyForLogin()
    *
    * Desc: SET State 'Bookingno is ready for Login?' Boolean.
    * Note:
    *
    */
    mut_FlagRebookingBookingnoLoginIsReadyForLogin: (state, payload) => {

        state.flagRebookingBookingnoLoginIsReadyForLogin = payload;

    }, // eof mut_FlagRebookingBookingnoLoginIsReadyForLogin()


    /***************************************************************************
    * mut_FlagRebookingShowBookingnoSearchResults()
    *
    * Desc: SET State/Flag 'Show Bookinno Overview Section'
    * Note: CONTROL FLAG
    *
    */
    mut_FlagRebookingShowBookingnoSearchResults: (state, payload) => {

        state.flagRebookingShowBookingnoSearchResults = payload;

    }, // eof mut_FlagRebookingShowBookingnoSearchResults()




    /***************************************************************************
    * Mutations: 'Bookingno Rebooking'
    ***************************************************************************/
    /***************************************************************************
    * mut_setRebookingUsersSearchDataBookingno()
    *
    * Desc: 'SET Users Search Data Bookingno & Birthdate'.
    * Note:
    *
    */
    mut_setRebookingUsersSearchDataBookingno: (state, payload) => {

        state.rebookingUsersSearchDataBookingno = payload;

    }, // eof mut_setRebookingUsersSearchDataBookingno()


    /***************************************************************************
    * mut_setRebookingAllPaxCheckboxClicked()
    *
    * Desc: Handle (add/remove) flightIds.
    * Note:
    *
    */
    mut_setRebookingAllPaxCheckboxClicked: (state, payload) => {

        let flightDirection = payload.split('_');


        if (!state.rebookingAllPaxCheckboxClicked.includes(flightDirection[1])) {
            state.rebookingAllPaxCheckboxClicked.push(flightDirection[1]);
        } else {
            var index = state.rebookingAllPaxCheckboxClicked.indexOf(flightDirection[1]);
            state.rebookingAllPaxCheckboxClicked.splice(index, 1);
        }

    }, // eof mut_setRebookingAllPaxCheckboxClicked()


    /***************************************************************************
    * mut_setRebookingIdTickets()
    *
    * Desc:
    * Note:
    *
    */
    mut_setRebookingIdTickets: (state, payload) => {

        state.rebookingIdTicketOutwards = payload.idTicketOutwards;
        state.rebookingIdTicketReturn = payload.idTicketReturn;

    }, // eof mut_setRebookingIdTickets()




    /***************************************************************************
    * Mutations: 'Calls', (Bookingno Rebooking)
    ***************************************************************************/
    /***************************************************************************
    * mut_setRebookingGetBookingResults()
    *
    * Desc: SET State 'getbooking' Object. Rebooking.
    * Note: Sort here: ADT => CHD
    *
    */
    mut_setRebookingGetBookingResults: (state, payload) => {

        payload.tickets.forEach((item, i) => {
            if (item.child === true) {
                item.order = 2;
            }
            if (item.child === false) {
                item.order = 1;
            }
        });

        payload.tickets.sort(function (a, b) {
            return a.order - b.order;
        });


        state.rebookingGetBookingResults = payload;

    }, // eo function mut_setRebookingGetBookingResults()




    /***************************************************************************
    * Mutations: RebookingFlightSearchResult
    ***************************************************************************/
    /***************************************************************************
    * mut_setRebookingUsersSearchDataFlightSearch()
    *
    * Desc: 'SET Users Search Data for FlightSearch'.
    * Note:
    *
    */
    mut_setRebookingUsersSearchDataFlightSearch: (state, payload) => {

        state.rebookingUsersSearchDataFlightSearch = payload;

    }, // eof mut_setRebookingFlightSearchResults()


    /***************************************************************************
    * mut_setRebookingFlightSearchResults()
    *
    * Desc: SET State 'Flight Search Results' Object. Rebooking.
    * Note:
    *
    */
    mut_setRebookingFlightSearchResults: (state, payload) => {

        state.rebookingFlightSearchResults = payload;

    }, // eof mut_setRebookingFlightSearchResults()


    /***************************************************************************
    * mut_FlagRebookingOutwardFlightSelected()
    *
    * Desc: SET State 'Outward Flight selected' Object.
    * Note:
    *
    */
    mut_FlagRebookingOutwardFlightSelected: (state, payload) => {

        state.flagRebookingOutwardFlightSelected = payload;

    }, // eof mut_FlagRebookingOutwardFlightSelected()


    /***************************************************************************
    * mut_FlagRebookingReturnFlightSelected()
    *
    * Desc: SET State 'Return Flight selected' Object.
    * Note:
    *
    */
    mut_FlagRebookingReturnFlightSelected: (state, payload) => {

        state.flagRebookingReturnFlightSelected = payload;

    }, // eof mut_FlagRebookingReturnFlightSelected()




    /***************************************************************************
    * Mutations: Update Cart
    ***************************************************************************/
    /***************************************************************************
    * mut_setRebookingUpdateCart()
    *
    * Desc:
    * Note: Set different States here.
    *
    */
    mut_setRebookingUpdateCart: (state, payload) => {

        if (payload.type === 'outward') {
            state.flagRebookingOutwardFlightSelected = true;
            state.rebookingFlightIdSelectedOutward = payload.flight.id;
            state.rebookingPriceIdSelectedOutward = payload.flight.prcs[0].id;
        }
        if (payload.type === 'return') {
            state.flagRebookingReturnFlightSelected = true;
            state.rebookingFlightIdSelectedReturn = payload.flight.id;
            state.rebookingPriceIdSelectedReturn = payload.flight.prcs[0].id;
        }

    }, // eof mut_setRebookingUpdateCart




    /***************************************************************************
    * Mutations: RebookingKey
    ***************************************************************************/
    /***************************************************************************
    * mut_setRebookingUsersSearchDataGetRebookingKey()
    *
    * Desc: 'SET Users Search Data for GetRebookingKey'.
    * Note:
    *
    */
    mut_setRebookingUsersSearchDataGetRebookingKey: (state, payload) => {

        state.rebookingUsersSearchDataGetRebookingKey = payload;

    }, // eof mut_setRebookingUsersSearchDataGetRebookingKey()


    /***************************************************************************
    * mut_setRebookingGetRebookingKeyResults()
    *
    * Desc: SET State 'getrebookingkey' Object. Rebooking.
    * Note: Sort here: ADT => CHD
    *
    */
    mut_setRebookingGetRebookingKeyResults: (state, payload) => {

        payload.tickets.forEach((item, i) => {
            if (item.child === true) {
                item.order = 2;
            }
            if (item.child === false) {
                item.order = 1;
            }
        });

        payload.tickets.sort(function (a, b) {
            return a.order - b.order;
        });

        state.rebookingGetRebookingKeyResults = payload;

    }, // eof mut_setRebookingGetRebookingKeyResults()




    /***************************************************************************
    * Mutations: processRebookiong
    ***************************************************************************/
    /***************************************************************************
    * mut_setRebookingUsersSearchDataProcessRebooking()
    *
    * Desc: 'SET Users Search Data for Process Rebooking'.
    * Note:
    *
    */
    mut_setRebookingUsersSearchDataProcessRebooking: (state, payload) => {

        state.rebookingUsersSearchDataProcessrebooking = payload;

    }, // eof mut_setRebookingUsersSearchDataProcessRebooking()


    /***************************************************************************
    * mut_setRebookingProcessRebookingResults()
    *
    * Desc: SET State 'processrebooking' Object. Rebooking.
    * Note:
    *
    */
    mut_setRebookingProcessRebookingResults: (state, payload) => {

        state.rebookingProcessRebookingResults = payload;

    }, // eof mut_setRebookingProcessRebookingResults()

};




//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$             /$$     /$$
// #   /$$__  $$           | $$    |__/
// #  | $$  \ $$  /$$$$$$$/$$$$$$   /$$  /$$$$$$  /$$$$$$$   /$$$$$$$
// #  | $$$$$$$$ /$$_____/_  $$_/  | $$ /$$__  $$| $$__  $$ /$$_____/
// #  | $$__  $$| $$       | $$    | $$| $$  \ $$| $$  \ $$|  $$$$$$
// #  | $$  | $$| $$       | $$ /$$| $$| $$  | $$| $$  | $$ \____  $$
// #  | $$  | $$|  $$$$$$$ |  $$$$/| $$|  $$$$$$/| $$  | $$ /$$$$$$$/
// #  |__/  |__/ \_______/  \___/  |__/ \______/ |__/  |__/|_______/
// #
//-----------------------------------------------------------------------------/
const actions = {

    /***************************************************************************
    * Actions: 'Bookingno Rebooking', Control Flags
    ***************************************************************************/
    /***************************************************************************
    * actn_FlagRebookingBookingnoLoginIsReadyForLogin()
    *
    * Desc: ACTION 'SET Flag: Bookingno Rebooking is ready for Login'.
    * Note:
    *
    */
    actn_FlagRebookingBookingnoLoginIsReadyForLogin: (context, payload) => {

        context.commit('mut_FlagRebookingBookingnoLoginIsReadyForLogin', payload); // calling mutation

    }, // eo function actn_FlagRebookingBookingnoLoginIsReadyForLogin()


    /***************************************************************************
    * actn_FlagRebookingShowBookingnoSearchResults()
    *
    * Desc: ACTION 'Show Bookinno Rebooking Overview Section'.
    * Note: CONTROL FLAG
    *
    */
    actn_FlagRebookingShowBookingnoSearchResults: (context, payload) => {

        context.commit('mut_FlagRebookingShowBookingnoSearchResults', payload); // calling mutation

    }, // eo function actn_FlagRebookingShowBookingnoSearchResults()




    /***************************************************************************
    * Actions: 'Bookingno Rebooking'
    ***************************************************************************/
    /***************************************************************************
    * actn_setRebookingUsersSearchDataBookingno()
    *
    * Desc: ACTION 'SET Users Search Data Bookingno & Birthdate'.
    * Note:
    *
    */
    actn_setRebookingUsersSearchDataBookingno: (context, payload) => {

        context.commit('mut_setRebookingUsersSearchDataBookingno', payload); // calling mutation

    }, // eo function actn_setRebookingUsersSearchDataBookingno()


    /***************************************************************************
    * actn_setRebookingAllPaxCheckboxClicked()
    *
    * Desc: ACTION 'SET AllPax CheckBox was licked. Save FlightId'.
    * Note:
    *
    */
    actn_setRebookingAllPaxCheckboxClicked: (context, payload) => {

        context.commit('mut_setRebookingAllPaxCheckboxClicked', payload); // calling mutation

    }, // eo function actn_setRebookingAllPaxCheckboxClicked()




    /***************************************************************************
    * Actions: 'Calls', Bookingno Rebooking
    ***************************************************************************/
    /***************************************************************************
    * Call::'/rebooking/getbooking'
    *
    * Desc: (Call) - 'Get Bookingoptions'.
    * Note:
    *
    */
    actn_call_rebookingGetBooking: (context, payload) => {

        let hdrs = '',
            trsnltd = '';


        // >>> Send Ajax Request --------------------------
        Vue.prototype.$vp_m();
        axios.put('/rebooking/getbooking/', payload)
            .then(function(response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        eventBus.$emit('readytoshowbookingforrebooking');       // emit .. 'ready to push 'passengers''
                        context.commit('mut_setRebookingGetBookingResults', response.data);
                        break;
                    default: // 'ERROR'
                        trsnltd = Vue.prototype.$trnsl_error_message(response.headers["air41-error"]);
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: trsnltd
                        });
                        break;
                };
            })
            .catch(function(error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_rebookingGetBooking()


    /***************************************************************************
    * actn_setRebookingIdTickets()
    *
    * Desc: ACTION 'SET idTickets'.
    * Note:
    *
    */
    actn_setRebookingIdTickets: (context, payload) => {

        context.commit('mut_setRebookingIdTickets', payload); // calling mutation

    }, // eo function actn_setRebookingIdTickets()


    /***************************************************************************
    * Call::'/rebooking/listflightsforrebooking'
    *
    * Desc: (Call) - 'Get Flights for Rebooking'.
    * Note:
    *
    */
    actn_call_listFlightsForRebooking: (context, payload) => {

        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        context.commit('mut_setRebookingUsersSearchDataFlightSearch', payload);

        Vue.prototype.$vp_m();
        axios.put('/rebooking/listflightsforrebooking/', payload)
            .then(function(response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        eventBus.$emit('readytoshowrebookingflightsearchresults'); // emit .. 'ready to push 'passengers''
                        context.commit('mut_setRebookingFlightSearchResults', response.data.listFlightsRS.flts);
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message : response.headers["air41-error"]
                        });
                        break;
                };
            })
            .catch(function(error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_listFlightsForRebooking()


    /***************************************************************************
    * actn_FlagRebookingOutwardFlightSelected()
    *
    * Desc: ACTION 'Outward Flight selected?'.
    * Note: CONTROL FLAG
    *
    */
    actn_FlagRebookingOutwardFlightSelected: (context, payload) => {

        context.commit('mut_FlagRebookingOutwardFlightSelected', payload); // calling mutation

    }, // eof actn_FlagRebookingOutwardFlightSelected()


    /***************************************************************************
    * actn_FlagRebookingReturnFlightSelected()
    *
    * Desc: ACTION 'Return Flight selected?'.
    * Note: CONTROL FLAG
    *
    */
    actn_FlagRebookingReturnFlightSelected: (context, payload) => {

        context.commit('mut_FlagRebookingReturnFlightSelected', payload); // calling mutation

    }, // eof actn_FlagRebookingReturnFlightSelected()




    /***************************************************************************
    * Actions: Update Cart
    ***************************************************************************/
    /***************************************************************************
    * actn_setRebookingUpdateCart()
    *
    * Desc: ACTION 'Update Cart'.
    * Note:
    *
    */
    actn_setRebookingUpdateCart: (context, payload) => {

        context.commit('mut_setRebookingUpdateCart', payload); // calling mutation

    }, // eof actn_setRebookingUpdateCart()




    /***************************************************************************
    * Actions: RebookingKey
    ***************************************************************************/
    /***************************************************************************
    * Call::'/rebooking/getrebookingkey'
    *
    * Desc: (Call) - 'Get Rebookingkey'.
    * Note: Translated Error Message.
    * Note: Special Case here: Emits Event also in Case of some special Error.
    *
    */
    actn_call_getRebookingKey: (context, payload) => {

        let hdrs = '',
            nsa = '',
            nsb = '',
            splittedMessage = '',
            trsnltd = '';


        // >>> Send Ajax Request --------------------------
        context.commit('mut_setRebookingUsersSearchDataGetRebookingKey', payload); // emit ..

        Vue.prototype.$vp_m();
        axios.put('/rebooking/getrebookingkey/', payload)
            .then(function(response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        eventBus.$emit('readytoshowrebookingspayment');         // emit .. 'ready to push 'payment''
                        context.commit('mut_setRebookingGetRebookingKeyResults', response.data);
                        break;
                    default: // 'ERROR'
                        trsnltd = Vue.prototype.$trnsl_error_message(response.headers["air41-error"]);
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: trsnltd
                        });

                        // >>> Error 120102 ? ---
                        nsa = response.headers["air41-error"].substring(1); // del 1st
                        nsb = nsa.substr(0, nsa.length - 1); // del last
                        splittedMessage = nsb.split(']['); // split
                        if (splittedMessage[0] === '120102') {
                            eventBus.$emit('errorrebookingnoservicesanymore'); // emit .. 'error .. no services anymore'
                        }

                        break;
                };
            })
            .catch(function(error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_getRebookingKey()




    /***************************************************************************
    * Actions: processrebooking
    ***************************************************************************/
    /*************************************************************************** 'Version 2 is Tmp only'
    * Call::'/rebooking/processrebooking2'
    *
    * Desc: (Call) - 'process rebooking'.
    * Note: THIS IS USING 'processBooking2'. An enhanced Copy of Original.
    *
    */
    actn_call_processRebooking: (context, payload) => {

        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        context.commit('mut_setRebookingUsersSearchDataProcessRebooking', payload);

        Vue.prototype.$vp_m();
        axios.put('/rebooking/processrebooking2/', payload)
            .then(function (response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        // >>> ----------------------------
                        if (response.data.status !== 'KO') {
                            context.commit('mut_setRebookingProcessRebookingResults', response.data);
                            eventBus.$emit('readytoshowrebookingsconfirmation'); // emit .. 'ready to push 'confirmation' (original)
                            eventBus.$emit('readytoshowbookingsconfirmationoncheckout', response.data); // emit .. 'ready to push 'confirmation' (checkout)
                        }

                        // >>> ----------------------------
                        if (response.data.status === 'KO') {
                            eventBus.$emit('errorinconfirmation', response.data); // emit ... 'Error'
                            Vue.prototype.$toasted.global.sdr_app_error({
                                message: response.data.errors[0].errorMessage
                            });
                        }
                        break;
                    default: // 'ERROR'
                        eventBus.$emit('errorinconfirmation', response.data); // emit ... 'Error'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                };
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_processRebooking()

};




//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
export default {
    state,
    getters,
    mutations,
    actions,
};


// WEBPACK FOOTER //
// ./src/store/modules/rebooking/rebooking.js